import { RefObject } from "react";
import Button from "../common/Button";
import ListDetailModal from "../common/ListDetailModal";
import { FileDetailView } from "../Files/FileDetail";
import FilesList, { unreadableReason } from "../Files/FilesList";
import { FilesItem } from "../Files/api";

// "Fill from Files": the Files list itself, in a modal. Tick files, or click one
// to look at it (the same viewer as the Files page) and use it from there.
const FilesFillPickerModal: React.FC<{
  modalRef: RefObject<HTMLDialogElement>;
  onFill: (files: FilesItem[]) => void;
}> = ({ modalRef, onFill }) => {
  const fill = (files: FilesItem[]) => {
    if (!files.length) return;
    modalRef.current?.close();
    onFill(files);
  };

  return (
    <ListDetailModal<FilesItem>
      modalRef={modalRef}
      title="Fill form from Files"
      renderList={(open) => (
        <FilesList
          picker={{
            confirmLabel: (n) => `Fill form with ${n} file${n === 1 ? "" : "s"}`,
            onConfirm: fill,
            onOpenFile: open,
          }}
        />
      )}
      renderDetail={(item, back) => (
        <FileDetailView
          source={item.source}
          id={item.id}
          embedded
          onBack={back}
          actions={(file) => (
            <Button variant="primary" size="sm" disabled={!!unreadableReason(file)} title={unreadableReason(file)} onClick={() => fill([file])}>
              Fill form with this file
            </Button>
          )}
        />
      )}
    />
  );
};

export default FilesFillPickerModal;
